import React, { useEffect, useState } from 'react';
import FormContainer from './FormContainer';
import EyeIcon from '../../components/icons/EyeIcon';
import EyeSlashFillIcon from '../../components/icons/EyeSlashFillIcon';
import { LoginUser, Authenticated } from '../../API/auth';
import { getSetting } from '../../API/admin';
import { useLocation, useNavigate } from 'react-router-dom'; // Import necessary hooks
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import Swal from "sweetalert2";

function Login() {
	let navigate = useNavigate();
	const dispatch = useDispatch()
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [errorMessage, setErrorMessage] = useState(''); // State for error message
	const location = useLocation(); // Hook to get the current location
	const [TournamentOff, setTouramentOff] = useState([]);

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			let callAPI = async () => {
				const verifyToken = {
					token: token,
				}
				let res = await Authenticated(verifyToken)
				if (res.data.status) {
					// enqueueSnackbar('.', { variant: 'error' });
					navigate('/dashboard');
				}
			}
			callAPI()
		}

	}, []);

	useEffect(() => {
		let callAPI = async () => {
			let res = await getSetting()

			if (res.status) {
				res.data.map((entry, index) => {
					if (entry.value == 'false' && entry.name === 'tournament_register') {
						setTouramentOff(true);
					}
				})
			} else {
				// setIsOn(null);
				enqueueSnackbar('unable to fetch setting', {
					variant: 'error', action: (key) => (
						<button className='toast_close_btn'
							onClick={() => {
								// Close the Snackbar
								closeSnackbar(key);
							}}
						>
							X
						</button>
					),
				})
			}
		}
		callAPI()
	}, [])
	const [showPassword, setShowPassword] = useState(true);
	const [formData, setFormData] = useState({
		email: '',
		password: ''
	})


	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	const HandelChange = (event) => {
		const { name, value } = event.target;
		setFormData(prevState => ({
			...prevState,
			[name]: value
		}));
		setErrorMessage(''); // Clear error message on input change
	}

	const HandelSubmit = async (event) => {
		event.preventDefault();
		console.log("LOGggggggggggginnnnnnnnnnnnn");

		let res = await LoginUser(formData);
		if (res.data.token) {
			console.log('user = ', res.data.data);
			dispatch({ type: 'set', user: res.data.data });
			dispatch({ type: 'set', token: res.data.token });
			localStorage.setItem('token', res.data.token);
			localStorage.setItem('role', res.data.data.role);
			enqueueSnackbar(res.data.message, {
				variant: 'success', action: (key) => (
					<button className='toast_close_btn'
						onClick={() => {
							// Close the Snackbar
							closeSnackbar(key);
						}}
					>
						X
					</button>
				),
			});
			const redirectUrl = new URLSearchParams(location.search).get('redirect');
			console.log(redirectUrl);
			const url = new URL(redirectUrl, window.location.origin); // Using current origin to parse

			// Extract the pathname and search parameters
			const trimmedUrl = url.pathname + url.search;
			if (res.data.isnew != null && res.data.isnew == true && res.data.waitlist == false) {
				console.log("im hree")
				window.location.href = redirectUrl === null || undefined ? '/dashboard' : redirectUrl;
			}
			else {

				window.location.href = redirectUrl === null || undefined ? '/dashboard' : redirectUrl;

			}

		}
		// else {
		// 	// enqueueSnackbar(res.data.message, { variant: 'error' });
		// 	setErrorMessage(res.data.message); // Set the error message
		// }

		else {
			// Displaying error message in SweetAlert instead of Snackbar
			Swal.fire({
				title: "Credentials are not correct",
				// text: "Try again", // Error message from response
				icon: 'error',           // Display the 'error' icon
				confirmButtonColor: '#B2022F', // Button color
				confirmButtonText: 'Try again' // Button text
			});

			// setErrorMessage(res.data.message); // Optionally set the error message in state as well (if needed)
		}
	}

	return (
		<>
			<FormContainer>
				<form className='' onSubmit={HandelSubmit}>
					<label className='form-title mb-1' > LOGIN </label>
					{/* <p className='form-heading mb-3 login_sub_txt' style={{ lineHeight: "24px" , marginTop:"-4px" }}> Join UPG App create fun and earn money and create team enjoyed games.</p> */}
					<div className='form-outline mb-4'>
						<label className='mb-2 input-label' htmlFor="email">Email address</label>
						<input
							type='text'
							name='email'
							placeholder='Email'
							className='form-control bg-transparent form-input'
							onChange={HandelChange}
							value={formData.email}
							required
						/>
					</div>
					<div className="form-outline mb-1">
						<label className='mb-2 input-label' htmlFor="password">Password</label>
						<div className="position-relative">
							<input
								type={showPassword ? "password" : "text"}
								placeholder='Password'
								name='password'
								className='form-control bg-transparent form-input'
								onChange={HandelChange}
								value={formData.password}
								required
							/>
							<i className="btn btn-outline-secondary border-0 position-absolute end-0 top-0" type="button" id="togglePassword" onClick={togglePasswordVisibility}>
								{
									showPassword ? <EyeIcon /> : <EyeSlashFillIcon />
								}
							</i>
						</div>
						{errorMessage && <div className="text-danger mt-1 login_page_error_popup">{errorMessage}</div>} {/* Render error message */}
					</div>
					<p className='small mb-5 pb-lg-2 mt-1'>
						<a className='float-end login-navigation' href='#' onClick={(event) => { event.preventDefault(); navigate('/forgot-password') }}>
							Forgot password?
						</a>
					</p>
					<div className='pt-1 mb-1 mt-2'>
						<button className='btn btn-light w-100 border-0 px-3 py-3 fs-5 text-white submit-button' type='submit' > Login </button>
						{
							TournamentOff == false ? (<>
								<div className="text-end pt-2">
									<span className=' mt-2 below-button'>Don`t Have Account Yet? <span class="cursor-pointer heading-color" onClick={() => { navigate('/register') }}>Register Now</span></span>
								</div>
							</>) : null
						}

					</div>
				</form>
			</FormContainer>
		</>
	)
}
export default Login
